import { configureStore } from '@reduxjs/toolkit';
//slices
import authentication from './authentication';
import dashboardReducer from './dashboard';

export const store = configureStore({
  reducer: {
    authentication: authentication,
    dashboard:dashboardReducer
  },
})